import React, { PropsWithChildren, isValidElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { datadogRum } from '@datadog/browser-rum';

const Wrapper = styled.div`
  background-color: ${props => props.theme.color.validation.error};
  border-radius: 3px;
  color: white;
  font-size: 14px;
  max-width: 315px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  text-align: center;

  position: relative;
  margin-bottom: 1rem;
  z-index: 2;

  &:after {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    content: '';
    width: 0;
    height: 0;
    border-top: solid 10px ${props => props.theme.color.validation.error};
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
`;

const hasChildren = (element: React.ReactNode) =>
  isValidElement(element) && Boolean(element.props.children);

const ReactChildrenText: (
  children: React.ReactNode
) => string | number | boolean = (children: React.ReactNode) => {
  if (children && hasChildren(children))
    return ReactChildrenText((children as React.ReactElement).props.children);
  return children as string | number | boolean;
};

const FormErrorV2: React.FC<PropsWithChildren<any>> = ({
  children,
  ...rest
}) => {
  useEffect(() => {
    const text = ReactChildrenText(children);
    datadogRum.addError(new Error(text.toString()), {
      customType: 'formError'
    });
  }, []);
  return <Wrapper {...rest}>{children}</Wrapper>;
};

FormErrorV2.propTypes = {
  children: PropTypes.node.isRequired
};

export default FormErrorV2;
